import angular from 'angular';
import uiRouter from 'angular-ui-router';
import receiptsComponent from './receipts.component';
import dataTable from 'angular-material-data-table';

let receiptsModule = angular.module('receipts', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('receipts', {
        url: '/receipts?quoteId',
        component: 'receipts',
        parent: 'main',
        data: {
            permissions: {
                only: ['OPERATOR'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('receipts', receiptsComponent)
.name;

export default receiptsModule;
